
export const MEDIA_CONTEXT_TEMPLATE = 'mediiiawards';

export enum COMPETITIONS_CONTEXTS {
    main = 'main',
    main_hse = 'main_hse',
    exams = 'exams',
    hsecompetition = 'hsecompetition',
    creativelab = 'creativelab',
    videocompetition = 'videocompetition',
    hsevisualresearch = 'hsevisualresearch',
    projectfair_deziiign = 'projectfair_deziiign',
    projectfair_hse = 'projectfair_hse',
    concept = 'concept',
    mediiiaawards = 'mediiiaawards',
    partners_mediiia = 'partners_mediiia',
    tsawards = 'tsawards',
    artmediiiawards = 'artmediiiawards',
    photomediiiawards = 'photomediiiawards',
    cinemediiiawards = 'cinemediiiawards',
    aimediiiawards = 'aimediiiawards',
    historymediiiawards = 'historymediiiawards',
    storiesmediiiawards = 'storiesmediiiawards',
    automediiiawards = 'automediiiawards',
    musicmediiiawards = 'musicmediiiawards',
    foodmediiiawards = 'foodmediiiawards',
    eventmediiiawards = 'eventmediiiawards',
    profmediiiawards = 'profmediiiawards',
    astromediiiawards = 'astromediiiaawards',
    conceptmediiiawards = 'conceptmediiiawards',
    partners_deziiign = 'partners_deziiign',
    fdawards = 'fdawards',
    udawards = 'udawards',
    gdawards = 'gdawards',
    partners_hse = 'partners_hse',
    partners_creativecity = 'partners_creativecity',
    partners_competitions = 'partners_dafes',
    genius = 'genius',
    dcompetitionvc = 'dcompetitionvc',
    dcompetitione = 'dcompetitione',
    dcompetitionf = 'dcompetitionf',
    designfactory = 'designfactory',
    hsecompetitionse = 'hsecompetitionse',
    hsecompetitionoc = 'hsecompetitionoc',
    dafecpd = 'dafecpd',
    dafesvr = 'dafesvr',
    dafesvrfp = 'dafesvrfp',
    dafesvrid = 'dafesvrid',
    dafesvrbd = 'dafesvrbd',
    lectures = 'lectures',
    storytelling = 'storytelling',
    scenarios = 'scenarios',
    briefs = 'briefs',
    edu_design = 'edu_design',
    edu_art = 'edu_art',
    edu_fashion = 'edu_fashion',
    edu_events = 'edu_events',
    edu_dafes = 'edu_dafes',
    edu_startups = 'edu_startups',
    openCalls = 'hseopencalls',
    citycompetitions = 'citycompetitions',
    openCallsDeziiign = 'deziiignopencalls',
    ratings = 'ratings',
    main_portfolio = 'main_portfolio',
    sportmediiiawards = 'sportmediiiawards',
    kiiids_awards = 'kiiids_awards',
    mediiiaurbanawards = 'urbanawards',
    hsecreativeawards = 'hsecreativeawards',
    greenaward = 'greenaward',
    lastgreenaward = 'lastgreenaward',
    adcrawards = 'adcrawards',
    brndawards = 'brndawards',
    allDeziiign = 'allDeziiign',
    educationmediiiawards = 'educationmediiiawards',
    booksmediiiawards = 'booksmediiiawards',
    ldAwards = 'ldawards',
    hsespace_awards = 'hsespace_awards',
    briefs_hsespace = 'briefs_hsespace',
    biologyawards = 'biologyawards',
    advertisingandprawards = 'advertisingandprawards',
    orientalawards = 'orientalawards',
    geographyawards = 'geographyawards',
    publicadministrationawards = 'publicadministrationawards',
    urbandevelopmentawards = 'urbandevelopmentawards',
    computerscienceandengineeringawards = 'computerscienceandengineeringawards',
    historyawards = 'historyawards',
    arthistoryawards = 'arthistoryawards',
    cinemaawards = 'cinemaawards',
    culturologyawards = 'culturologyawards',
    mathematicsawards = 'mathematicsawards',
    mediaawards = 'mediaawards',
    internationalrelationsawards = 'internationalrelationsawards',
    managementawards = 'managementawards',
    musicawards = 'musicawards',
    politicalscienceawards = 'politicalscienceawards',
    softwareengineeringawards = 'softwareengineeringawards',
    productionawards = 'productionawards',
    psychologyawards = 'psychologyawards',
    sociologyawards = 'sociologyawards',
    physicsawards = 'physicsawards',
    philologyawards = 'philologyawards',
    philosophyawards = 'philosophyawards',
    chemistryawards = 'chemistryawards',
    economyawards = 'economyawards',
    jurisprudenceawards = 'jurisprudenceawards',
    filmawards = 'filmawards',
    hsettoawards = 'hsettoawards',
    hsecreativehubawards = 'hsecreativehubawards',
    allcontests = 'allcontests',
    dafesawards = 'dafesawards',
    naturemediiiawards = 'naturemediiiawards',
  }

  export const getMediiiaCompetitionContext = (ctxName: string) => {
    let ctxList: any = {};
    const computedCtx = ctxName.toLowerCase() + MEDIA_CONTEXT_TEMPLATE;
    ctxList[computedCtx] = computedCtx

    return computedCtx
  }

export const MEDIA_CONTEXT_TEMPLATE = 'mediiiawards';

export enum COMPETITIONS_CONTEXTS {
    main = 'main',
    main_hse = 'main_hse',
    exams = 'exams',
    hsecompetition = 'hsecompetition',
    creativelab = 'creativelab',
    videocompetition = 'videocompetition',
    hsevisualresearch = 'hsevisualresearch',
    projectfair_deziiign = 'projectfair_deziiign',
    projectfair_hse = 'projectfair_hse',
    concept = 'concept',
    mediiiaawards = 'mediiiaawards',
    partners_mediiia = 'partners_mediiia',
    tsawards = 'tsawards',
    artmediiiawards = 'artmediiiawards',
    photomediiiawards = 'photomediiiawards',
    cinemediiiawards = 'cinemediiiawards',
    aimediiiawards = 'aimediiiawards',
    historymediiiawards = 'historymediiiawards',
    storiesmediiiawards = 'storiesmediiiawards',
    automediiiawards = 'automediiiawards',
    musicmediiiawards = 'musicmediiiawards',
    foodmediiiawards = 'foodmediiiawards',
    eventmediiiawards = 'eventmediiiawards',
    profmediiiawards = 'profmediiiawards',
    astromediiiawards = 'astromediiiaawards',
    conceptmediiiawards = 'conceptmediiiawards',
    partners_deziiign = 'partners_deziiign',
    fdawards = 'fdawards',
    udawards = 'udawards',
    gdawards = 'gdawards',
    partners_hse = 'partners_hse',
    partners_creativecity = 'partners_creativecity',
    partners_competitions = 'partners_dafes',
    genius = 'genius',
    dcompetitionvc = 'dcompetitionvc',
    dcompetitione = 'dcompetitione',
    dcompetitionf = 'dcompetitionf',
    designfactory = 'designfactory',
    hsecompetitionse = 'hsecompetitionse',
    hsecompetitionoc = 'hsecompetitionoc',
    dafecpd = 'dafecpd',
    dafesvr = 'dafesvr',
    dafesvrfp = 'dafesvrfp',
    dafesvrid = 'dafesvrid',
    dafesvrbd = 'dafesvrbd',
    lectures = 'lectures',
    storytelling = 'storytelling',
    scenarios = 'scenarios',
    briefs = 'briefs',
    edu_design = 'edu_design',
    edu_art = 'edu_art',
    edu_fashion = 'edu_fashion',
    edu_events = 'edu_events',
    edu_dafes = 'edu_dafes',
    edu_startups = 'edu_startups',
    openCalls = 'hseopencalls',
    citycompetitions = 'citycompetitions',
    openCallsDeziiign = 'deziiignopencalls',
    ratings = 'ratings',
    main_portfolio = 'main_portfolio',
    sportmediiiawards = 'sportmediiiawards',
    kiiids_awards = 'kiiids_awards',
    mediiiaurbanawards = 'urbanawards',
    hsecreativeawards = 'hsecreativeawards',
    greenaward = 'greenaward',
    lastgreenaward = 'lastgreenaward',
    adcrawards = 'adcrawards',
    brndawards = 'brndawards',
    allDeziiign = 'allDeziiign',
    educationmediiiawards = 'educationmediiiawards',
    booksmediiiawards = 'booksmediiiawards',
    ldAwards = 'ldawards',
    hsespace_awards = 'hsespace_awards',
    briefs_hsespace = 'briefs_hsespace',
    biologyawards = 'biologyawards',
    advertisingandprawards = 'advertisingandprawards',
    orientalawards = 'orientalawards',
    geographyawards = 'geographyawards',
    publicadministrationawards = 'publicadministrationawards',
    urbandevelopmentawards = 'urbandevelopmentawards',
    computerscienceandengineeringawards = 'computerscienceandengineeringawards',
    historyawards = 'historyawards',
    arthistoryawards = 'arthistoryawards',
    cinemaawards = 'cinemaawards',
    culturologyawards = 'culturologyawards',
    mathematicsawards = 'mathematicsawards',
    mediaawards = 'mediaawards',
    internationalrelationsawards = 'internationalrelationsawards',
    managementawards = 'managementawards',
    musicawards = 'musicawards',
    politicalscienceawards = 'politicalscienceawards',
    softwareengineeringawards = 'softwareengineeringawards',
    productionawards = 'productionawards',
    psychologyawards = 'psychologyawards',
    sociologyawards = 'sociologyawards',
    physicsawards = 'physicsawards',
    philologyawards = 'philologyawards',
    philosophyawards = 'philosophyawards',
    chemistryawards = 'chemistryawards',
    economyawards = 'economyawards',
    jurisprudenceawards = 'jurisprudenceawards',
    filmawards = 'filmawards',
    hsettoawards = 'hsettoawards',
    hsecreativehubawards = 'hsecreativehubawards',
    allcontests = 'allcontests',
    dafesawards = 'dafesawards',
    naturemediiiawards = 'naturemediiiawards',
  }

  export const getMediiiaCompetitionContext = (ctxName: string) => {
    let ctxList: any = {};
    const computedCtx = ctxName.toLowerCase() + MEDIA_CONTEXT_TEMPLATE;
    ctxList[computedCtx] = computedCtx

    return computedCtx
  }
